// extracted by mini-css-extract-plugin
module.exports = {"indexKeyVisualImage":"CoverSlide_indexKeyVisualImage__wX5Pu","disabled":"CoverSlide_disabled__m_IJf"};